import { render, staticRenderFns } from "./StatisticCardVerticalCompleted.vue?vue&type=template&id=56988418&"
import script from "./StatisticCardVerticalCompleted.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports